const getFinalValue = ({
  rebatedPrice,
  originalPrice,
  rebateAddOns,
  programAddOns,
  totalRebateAvailable
}) => {

  // rebatedPrice,originalPrice,rebateAddOns,addOns,totalRebateAvailable

  let adjustedPrice = rebatedPrice - totalRebateAvailable;

  if (rebateAddOns.length > 0) {

    //  adjustedPrice=rebatedPrice
    const isineligibilityRebate = rebateAddOns.findIndex(
      discount => discount && discount.value !== '$0.00'
    ) === -1;

    if (isineligibilityRebate) {  //if applied rebateAddOns is not eligible
      adjustedPrice = originalPrice
    } else {
      const totalRebateApplied = rebateAddOns.reduce((acc, curr) => {
        return acc + (Number(curr.value.replace("$", "")) * -1);
      }, 0);
      adjustedPrice = originalPrice - totalRebateApplied
    }


    if (programAddOns.length > 0) {

      let afterProgramAddOn = adjustedPrice - totalRebateAvailable;

      const isineligibilityOption = programAddOns.findIndex(
        discount => discount && discount.value !== '$0.00'
      ) === -1;

      if (isineligibilityOption) {       //if applied program is not eligible  
        adjustedPrice = afterProgramAddOn + totalRebateAvailable;
      } else {
        adjustedPrice = afterProgramAddOn
      }
    }
  }
  return adjustedPrice
};

const getBillCreditAmount = (
  addOns,
  rebatesApplied,
  price,
  rebatePrice,

) => {

  try {
    let totalRebateAvailable = 0;
    const { rebates: rebateAddOns = [] } = rebatesApplied
    const { rebates: programAddOns = [] } = addOns

    const { sales: { value: originalPrice } } = price;
    const { sales: { value: rebatedPrice } } = rebatePrice;

    if (addOns.bonus) {
      totalRebateAvailable = addOns.bonus.rebateValue
    }


    const displayPrice = getFinalValue({ rebatedPrice, originalPrice, rebateAddOns, programAddOns, totalRebateAvailable });

    if (displayPrice <= -1) {
      const totalBillCredit = Number(displayPrice) && displayPrice * -1
      const onBill = totalRebateAvailable - totalBillCredit
      const onElecticity = totalBillCredit;
      return {
        onBill,
        onElecticity
      }
    } else {
      return null;
    }
  } catch (err) {
    console.log("error in getBillCreditAmount.js file", err);
    return null;
  }
};

export default getBillCreditAmount;
